<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiHelpCircle } from "@mdi/js";
export default {
  name: "MdiHelpCircle",
  data() {
    return {
      svgPath: mdiHelpCircle,
    };
  },
};
</script>
